var _style, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 295,
    viewBox: "0 0 528 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes kf_Avatar_transform_0 {\n  0% {\n    transform: translateX(70px) translateY(81px) translateX(48.259px) translateY(0px);\n  }\n  20% {\n    transform: translateX(70px) translateY(81px) translateX(-0.001px) translateY(0px);\n  }\n  100% {\n    transform: translateX(70px) translateY(81px) translateX(-0.001px) translateY(0px);\n  }\n}\n@keyframes kf_Avatar_opacity_0 {\n  0% {\n    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n    opacity: 0;\n  }\n  15.26% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  90% {\n    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n#Avatar {\n  transform-origin: 0 0;\n  animation:\n    kf_Avatar_transform_0 5s linear infinite,\n    kf_Avatar_opacity_0 5s linear infinite;\n}\n@keyframes kf_Information_opacity_0 {\n  0% {\n    animation-timing-function: linear;\n    opacity: 0;\n  }\n  20% {\n    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n    opacity: 0;\n  }\n  30% {\n    animation-timing-function: linear;\n    opacity: 1;\n  }\n  90% {\n    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n#Information {\n  animation: kf_Information_opacity_0 5s linear infinite;\n}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Provider_Information",
    clipPath: "url(#clip0_1490_58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Monitor",
    transform: "translate(104.908 30.3681)",
    d: "M20.3721 1.10449H297.665C308.306 1.10449 316.933 9.73101 316.933 20.3721V197.175C316.932 207.816 308.306 216.441 297.665 216.441H20.3721C9.73116 216.441 1.10472 207.816 1.10449 197.175V20.3721C1.10449 9.73101 9.73101 1.10449 20.3721 1.10449Z",
    fill: "white",
    stroke: "#F4F6F9",
    strokeWidth: 2.20859
  }), /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(70 81)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1490_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.482,
    height: 115.482,
    rx: 112.118,
    id: "Avatar_bg_0",
    fill: "#EFF9F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(33 22.3799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4477 46.1261C39.5023 46.1261 50.8955 57.5193 50.8955 71.5738V101.997C50.8955 105.983 47.6643 109.215 43.6779 109.216H31.5453C14.1235 109.216 0 95.092 0 77.6702V71.5738C0 57.5194 11.3933 46.1262 25.4477 46.1261Z",
    id: "Person_bg_0",
    fill: "#80CEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3755 0C36.2575 1.8491e-05 45.0792 8.82193 45.0794 19.7039C45.0794 30.586 36.2576 39.4077 25.3755 39.4078C14.4933 39.4078 5.6716 30.586 5.6716 19.7039C5.6718 8.82192 14.4935 0 25.3755 0Z",
    fill: "#80CEB7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Plus",
    transform: "translate(58.7871 80.7251)",
    d: "M9.13754 0C10.0044 -3.78932e-08 10.7073 0.70285 10.7073 1.56975V6.11042H15.248C16.1149 6.11042 16.8177 6.81327 16.8177 7.68017V9.13754C16.8177 10.0044 16.1149 10.7073 15.248 10.7073H10.7073V15.248C10.7073 16.1149 10.0044 16.8177 9.13754 16.8177H7.68017C6.81327 16.8177 6.11042 16.1149 6.11042 15.248V10.7073H1.56975C0.70285 10.7073 0 10.0044 0 9.13754V7.68017C0 6.81327 0.70285 6.11042 1.56975 6.11042H6.11042V1.56975C6.11042 0.70285 6.81327 3.78933e-08 7.68017 0H9.13754Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Information",
    transform: "translate(204 82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 30,
    rx: 8,
    id: "Line_bg_0",
    fill: "#F4F6F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_2",
    transform: "translate(0 43)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 30,
    rx: 8,
    id: "Line_2_bg_0",
    fill: "#F4F6F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_3",
    transform: "translate(0 85)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 30,
    rx: 8,
    id: "Line_3_bg_0",
    fill: "#F4F6F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 30,
    rx: 8,
    id: "Fill_bg_0",
    fill: "#E9EDF4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 34.537; 49.159; 63.043; 76.225; 88.699; 100.443; 111.415; 121.56; 130.807; 139.063; 146.212; 152.104; 153.275; 154.366; 155.372; 156.29; 157.118; 157.85; 158.484; 159.014; 159.436; 159.745; 159.935; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160; 160",
    keyTimes: "0; 0.0127; 0.0254; 0.0381; 0.0509; 0.0636; 0.0763; 0.089; 0.1017; 0.1144; 0.1271; 0.1399; 0.1526; 0.1565; 0.1605; 0.1644; 0.1684; 0.1723; 0.1763; 0.1802; 0.1842; 0.1881; 0.1921; 0.196; 0.2; 0.2083; 0.2167; 0.225; 0.2333; 0.2417; 0.25; 0.2583; 0.2667; 0.275; 0.2833; 0.2917; 0.3; 0.3017; 0.3033; 0.305; 0.3067; 0.3083; 0.31; 0.3117; 0.3133; 0.315; 0.3167; 0.3183; 0.32; 0.3295; 0.3389; 0.3484; 0.3579; 0.3673; 0.3768; 0.3863; 0.3957; 0.4052; 0.4146; 0.4241; 0.4336; 0.4358; 0.438; 0.4402; 0.4424; 0.4446; 0.4468; 0.449; 0.4512; 0.4534; 0.4556; 0.4578; 0.46; 0.47; 0.48; 0.49; 0.5; 0.51; 0.52; 0.53; 0.54; 0.55; 0.56; 0.57; 0.58; 0.5811; 0.5823; 0.5834; 0.5846; 0.5857; 0.5868; 0.588; 0.5891; 0.5902; 0.5914; 0.5925; 0.5937; 0.6025; 0.6114; 0.6202; 0.6291; 0.638; 0.6468; 0.6557; 0.6646; 0.6734; 0.6823; 0.6911; 0.7; 0.7167; 0.7333; 0.75; 0.7667; 0.7833; 0.8; 0.8167; 0.8333; 0.85; 0.8667; 0.8833; 0.9; 0.9083; 0.9167; 0.925; 0.9333; 0.9417; 0.95; 0.9583; 0.9667; 0.975; 0.9833; 0.9917; 1",
    dur: "5s",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill_2",
    transform: "translate(0 43)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 30,
    rx: 8,
    id: "Fill_2_bg_0",
    fill: "#E9EDF4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 22.871; 26.66; 30.392; 34.074; 37.712; 41.308; 44.864; 48.382; 51.863; 55.307; 58.716; 62.089; 76.973; 91.147; 104.602; 117.31; 129.232; 140.313; 150.487; 159.668; 167.752; 174.606; 180.062; 183.903; 184.225; 184.523; 184.795; 185.041; 185.26; 185.452; 185.617; 185.753; 185.86; 185.937; 185.984; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186; 186",
    keyTimes: "0; 0.0127; 0.0254; 0.0381; 0.0509; 0.0636; 0.0763; 0.089; 0.1017; 0.1144; 0.1271; 0.1399; 0.1526; 0.1565; 0.1605; 0.1644; 0.1684; 0.1723; 0.1763; 0.1802; 0.1842; 0.1881; 0.1921; 0.196; 0.2; 0.2083; 0.2167; 0.225; 0.2333; 0.2417; 0.25; 0.2583; 0.2667; 0.275; 0.2833; 0.2917; 0.3; 0.3017; 0.3033; 0.305; 0.3067; 0.3083; 0.31; 0.3117; 0.3133; 0.315; 0.3167; 0.3183; 0.32; 0.3295; 0.3389; 0.3484; 0.3579; 0.3673; 0.3768; 0.3863; 0.3957; 0.4052; 0.4146; 0.4241; 0.4336; 0.4358; 0.438; 0.4402; 0.4424; 0.4446; 0.4468; 0.449; 0.4512; 0.4534; 0.4556; 0.4578; 0.46; 0.47; 0.48; 0.49; 0.5; 0.51; 0.52; 0.53; 0.54; 0.55; 0.56; 0.57; 0.58; 0.5811; 0.5823; 0.5834; 0.5846; 0.5857; 0.5868; 0.588; 0.5891; 0.5902; 0.5914; 0.5925; 0.5937; 0.6025; 0.6114; 0.6202; 0.6291; 0.638; 0.6468; 0.6557; 0.6646; 0.6734; 0.6823; 0.6911; 0.7; 0.7167; 0.7333; 0.75; 0.7667; 0.7833; 0.8; 0.8167; 0.8333; 0.85; 0.8667; 0.8833; 0.9; 0.9083; 0.9167; 0.925; 0.9333; 0.9417; 0.95; 0.9583; 0.9667; 0.975; 0.9833; 0.9917; 1",
    dur: "5s",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill_3",
    transform: "translate(0 85)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 30,
    rx: 8,
    id: "Fill_3_bg_0",
    fill: "#E9EDF4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19; 19.995; 20.991; 21.986; 22.981; 23.977; 24.972; 25.967; 26.963; 27.958; 28.953; 29.949; 30.944; 38.699; 46.453; 54.208; 61.963; 69.717; 77.472; 85.227; 92.981; 100.736; 108.491; 116.245; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124; 124",
    keyTimes: "0; 0.0127; 0.0254; 0.0381; 0.0509; 0.0636; 0.0763; 0.089; 0.1017; 0.1144; 0.1271; 0.1399; 0.1526; 0.1565; 0.1605; 0.1644; 0.1684; 0.1723; 0.1763; 0.1802; 0.1842; 0.1881; 0.1921; 0.196; 0.2; 0.2083; 0.2167; 0.225; 0.2333; 0.2417; 0.25; 0.2583; 0.2667; 0.275; 0.2833; 0.2917; 0.3; 0.3017; 0.3033; 0.305; 0.3067; 0.3083; 0.31; 0.3117; 0.3133; 0.315; 0.3167; 0.3183; 0.32; 0.3295; 0.3389; 0.3484; 0.3579; 0.3673; 0.3768; 0.3863; 0.3957; 0.4052; 0.4146; 0.4241; 0.4336; 0.4358; 0.438; 0.4402; 0.4424; 0.4446; 0.4468; 0.449; 0.4512; 0.4534; 0.4556; 0.4578; 0.46; 0.47; 0.48; 0.49; 0.5; 0.51; 0.52; 0.53; 0.54; 0.55; 0.56; 0.57; 0.58; 0.5811; 0.5823; 0.5834; 0.5846; 0.5857; 0.5868; 0.588; 0.5891; 0.5902; 0.5914; 0.5925; 0.5937; 0.6025; 0.6114; 0.6202; 0.6291; 0.638; 0.6468; 0.6557; 0.6646; 0.6734; 0.6823; 0.6911; 0.7; 0.7167; 0.7333; 0.75; 0.7667; 0.7833; 0.8; 0.8167; 0.8333; 0.85; 0.8667; 0.8833; 0.9; 0.9083; 0.9167; 0.925; 0.9333; 0.9417; 0.95; 0.9583; 0.9667; 0.975; 0.9833; 0.9917; 1",
    dur: "5s",
    calcMode: "linear",
    repeatCount: "indefinite"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1490_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 527.853,
    height: 294.294,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1490_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.482,
    height: 115.482,
    rx: 112.118,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.f521a0c233b9c0130568e4361f257551.svg";
export { ForwardRef as ReactComponent };